import { CONVERSATIONS_LOADER, DASHBOARD_LOADER, MESSAGES_LOADER } from "../action-types/loaderActionTypes";

const initialState = {
    conversationsLoader: {
        isLoading: false
    },
    messagesLoader: {
        isLoading: false
    },
    dashboardLoader: {
        isLoading: false
    }
}

export const loaderReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case CONVERSATIONS_LOADER:
            return {
                ...state,
                conversationsLoader: { ...action.payload }
            }
        case MESSAGES_LOADER:
            return {
                ...state,
                messagesLoader: { ...action.payload }
            }
        case DASHBOARD_LOADER:
            return {
                ...state,
                dashboardLoader: { ...action.payload }
            }

        default:
            return state
    }
}